import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateTipoUsuario } from "../../../redux/actions";
import { useState } from "react";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";
import Button from "../../../components/button";

function EliminarUsuarioComponent({ userId, onClose, onActualizacion }) {
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const [loading, setLoading] = useState(false);
  const openErrorModal = (message) => setErrorModal({ show: true, message });
  const closeErrorModal = () => setErrorModal({ show: false, message: "" });

  const {
    handleSubmit,
  } = useForm();

  const onSubmit = async () => {
    setLoading(true);
    const finalData = {
      tipo: "eliminado",
      id: userId
    };
    try {
      const response = await dispatch(updateTipoUsuario(finalData));
      if (response) {
        setShowSuccessModal(true);
        if (typeof onActualizacion === "function") {
          onActualizacion();
        }
      }
    } catch (error) {
      console.error(error);
      const serverErrorMessage = error.response?.data?.error || "Error inesperado al procesar la solicitud.";
      openErrorModal(serverErrorMessage);
    }
    setLoading(false);
  };

  const handleCloseSuccess = () => {
    setShowSuccessModal(false);
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose} /* Cierra al hacer clic fuera */
    >
      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={handleCloseSuccess}
          message="Usuario eliminado con éxito."
        />
      )}
      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
      <form
        onSubmit={handleSubmit(onSubmit)}
        onClick={(e) =>
          e.stopPropagation()
        } /* Evita que el clic dentro lo cierre */
      >
        <div className="w-[20rem] bg-white p-6 rounded-lg shadow-lg">
          <div className="text-2xl font-bold mb-4 text-center">
            Eliminar usuario
          </div>

          <div className="mb-4">
            <label className="block text-m font-medium mb-2 text-center">
              Confirma la eliminación de este usuario?
            </label>
          </div>

          <div className="flex flex-col justify-center gap-4">
            <Button type="submit" fullWidth loading={loading}>
              Confirmar
            </Button>
            <Button
              variant="secondary"
              fullWidth
              onClick={onClose}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EliminarUsuarioComponent;
